import { render } from "./KingOrGovernor.vue?vue&type=template&id=558882b9"
import script from "./KingOrGovernor.vue?vue&type=script&lang=js"
export * from "./KingOrGovernor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/KingOrGovernor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "558882b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('558882b9', __exports__)) {
    api.reload('558882b9', __exports__)
  }
  
  module.hot.accept("./KingOrGovernor.vue?vue&type=template&id=558882b9", () => {
    api.rerender('558882b9', render)
  })

}


export default __exports__